import component from "containers/StaticPages/createAccount";

export default {
  key: "password",
  title: "Password",
  path: "/:user?/password/:slug",
  linkTarget: "/password",
  component,
};
